"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var portalDomNodeRef = null;
exports.createPortalDomNode = function () {
    if (typeof document === 'undefined') {
        return null;
    }
    if (portalDomNodeRef) {
        return portalDomNodeRef;
    }
    var domNode = document.createElement('div');
    domNode.style.position = 'absolute';
    domNode.style.top = '0px';
    domNode.style.left = '0px';
    domNode.id = 'vm-react-portal';
    document.body.appendChild(domNode);
    portalDomNodeRef = domNode;
    return portalDomNodeRef;
};
//# sourceMappingURL=createPortalDomNode.js.map